import React, { useCallback, useRef } from 'react'
import { IconButton } from '@material-ui/core'
import SydInput from '../../../../commonDesign/SydInput'
import Icon from '../../../../atoms/Icon'
import { fsExcludeClass } from '../../../../../utils/fsExclude'
import { useUserLoginActivityContext } from './UserLoginActivityProvider'
import useDebouncedThrottledCommit from './useDebouncedThrottledCommit'

const CLEAR_ICON_SIZE = 18
const INPUT_CLEAR_PADDING = '28px'

const wrapperStyle = {
  position: 'relative',
  width: '100%',
  minWidth: '100%'
}

const clearButtonStyle = {
  position: 'absolute',
  right: '2px',
  top: '50%',
  transform: 'translateY(-50%)'
}

export default function UserFilter () {
  const { searchText, setSearchText } = useUserLoginActivityContext()
  const inputRef = useRef(null)

  const handleCommit = useCallback((term) => {
    const next = term?.trim() ?? ''
    if ((searchText ?? '') === next) {
      return
    }
    setSearchText(term)
  }, [searchText, setSearchText])

  const { inputValue, setInputValue, clearInput } = useDebouncedThrottledCommit(handleCommit)

  const handleChange = useCallback((e) => {
    setInputValue(e.target.value)
  }, [setInputValue])

  const handleClear = useCallback(() => {
    clearInput()
    setSearchText('')
    inputRef.current?.focus()
  }, [clearInput, setSearchText])

  const hasValue = Boolean(inputValue)

  return (
    <div style={wrapperStyle}>
      <SydInput
        ref={inputRef}
        size='sm'
        minWidth='100%'
        value={inputValue}
        onChange={handleChange}
        placeholder='Search by name or email'
        inputProps={{
          className: fsExcludeClass,
          style: hasValue ? { paddingRight: INPUT_CLEAR_PADDING } : undefined
        }}
      />
      {hasValue ? (
        <IconButton
          size='small'
          style={clearButtonStyle}
          onClick={handleClear}
          aria-label='Clear search'
        >
          <Icon name='close' customSize={CLEAR_ICON_SIZE} />
        </IconButton>
      ) : null}
    </div>
  )
}
